import React, { useRef, useState, useEffect } from "react";
import Slider from "react-slick";
import Link from "next/link";
import styles from "./ScrollingPartnership.module.scss";
import Image from "next/image";
import { ScrollingPartnershipSettings } from "./ScrollingPartnershipSettings";
import { useSelector } from "react-redux";
import { selectPageSearchData } from "../../redux/dataSlice";
import arrow from "../../assets/icons/arrow-right-white.svg";
import left from "../../assets/icons/left-circle-button.svg";
import right from "../../assets/icons/right-circle-button.svg";
import { processScrollingPartnershipData } from "../../utils/mapping";
import { propsType } from "./ScrollingPartnership.type";
import { addCommasToSchoolCard, handleApplicationRedirection } from "@/utils/helper";
import { useDispatch } from "react-redux";

const ScrollingPartnership = ({ isContact, isContent }: propsType) => {
  const dispatch = useDispatch();
  const data = useSelector(selectPageSearchData);
  const processedData = processScrollingPartnershipData(data);
  const {isMobileDevice} = useSelector((state:any)=>state?.data);

  const numberofresults = processedData?.results?.length;

  const sanitizedData = processedData?.searchresulttext
    ?.toString()
    ?.replace(
      "{numberofresults}",
      `<span class="${styles.noRes}">${numberofresults}</span>`
    );

  const customSlider = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(4); // Default to desktop view

  const gotoNext = () => {
    if (customSlider.current) {
      customSlider.current.slickNext();
    }
  };

  const gotoPrev = () => {
    if (customSlider.current) {
      customSlider.current.slickPrev();
    }
  };

  const handleBeforeChange = (oldIndex, newIndex) => {
    setCurrentIndex(newIndex);
  };

  useEffect(() => {
    const updateSlidesToShow = () => {
      if (window.innerWidth < 1024) {
        setSlidesToShow(1);
      } else {
        setSlidesToShow(4);
      }
    };

    window.addEventListener("resize", updateSlidesToShow);
    updateSlidesToShow();

    return () => {
      window.removeEventListener("resize", updateSlidesToShow);
    };
  }, []);

  const lastSlideIndex = processedData?.results?.length - slidesToShow;

  return (
    <div
      id="sliderwpcard"
      className={`sliderwpcard school-card-slider ${
        isContact ? "section_pading1" : "section_pading"
      } ${styles.sliderwpcard}`}
      data-testid="sp-container-id"
    >
      <div className="container">
        {/* <span className={`${styles.school_results} `}>Related Schools</span> */}
        {isContent && (
          <p
            className={styles.school_results}
            dangerouslySetInnerHTML={{ __html: sanitizedData }}
          />
        )}
        <div className={`slider-container sliderwp ${styles.sliderwp}`}>
          <Slider
            {...ScrollingPartnershipSettings}
            ref={customSlider}
            beforeChange={handleBeforeChange}
          >
            {processedData?.results?.map((school, index) => (
              <div key={index}>
                <div className={`alain ${styles.cardwp}`}>
                  <div
                    className={`searchSliderCard searchSliderCardBlue ${styles.searchSliderCard}`}
                  >
                    <div className={`${styles.searchSlider}`}>
                      <div>
                        <Image
                          src={
                            school?.schoolcard?.results?.[0]?.image
                              ?.results?.[0]?.fileUrl
                          }
                          alt={`${school?.name} image`}
                          width={280}
                          height={200}
                        />
                      </div>
                    </div>
                    <div className={`${styles.searchContent}`}>
                      <div className={`${styles.searchContentLogo}`}>
                        <Image
                          src={
                            school?.schoolcard?.results?.[0]?.logo?.results?.[0]
                              ?.fileUrl
                          }
                          alt="schoolcard"
                          width={195}
                          height={56}
                          priority={true}
                        />
                      </div>
                      <div
                        className={`${styles.searchTag} ${school?.schoolcard?.results?.[0]?.link?.results?.[0]?.class}`}
                      >
                        {school?.schoolcard?.results?.[0]?.gradeoryear}
                      </div>
                      <p className="d-flex align-items-center">
                        <Image
                          src={
                            school?.schoolcard?.results?.[0]?.curriculumicon
                              ?.results?.[0]?.fileUrl
                          }
                          alt="curriculum"
                          width={16}
                          height={16}
                          priority={true}
                          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                        />

                        <span className="ps-2">
                          {school?.schoolcard?.results?.[0]?.curriculum}
                        </span>
                      </p>
                      <p className="d-flex align-items-center">
                        <Image
                          src={
                            school?.schoolcard?.results?.[0]?.ratingicon
                              ?.results?.[0]?.fileUrl
                          }
                          alt="rating"
                          width={16}
                          height={16}
                          priority={true}
                          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                        />

                        <span className="ps-2">
                          {school?.schoolcard?.results?.[0]?.rating}
                        </span>
                      </p>
                      <h5>
                        <span>
                          {school?.schoolcard?.results?.[0]?.currency}
                        </span>{" "}
                        {addCommasToSchoolCard(school?.feemin)} -{" "}
                        {addCommasToSchoolCard(school?.feemax)}
                      </h5>
                      <Link
                        href={school?.schoolcard?.results?.[0]?.maplocationlink}
                        target="_blank"
                      >
                        <Image
                          src={
                            school?.schoolcard?.results?.[0]?.locationicon
                              ?.results[0]?.fileUrl
                          }
                          alt="location"
                          width={16}
                          height={16}
                          priority={true}
                          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                        />
                        <span className="ps-2">
                          {school?.schoolcard?.results?.[0]?.locationinfo}
                        </span>
                      </Link>
                      <span>
                        <Link
                          href={
                            school?.schoolcard?.results?.[0]?.link?.results?.[0]
                              ?.hyperlink
                          }
                        >
                          <button
                            className={`${styles.buttonSearchBlue} ${school?.schoolcard?.results?.[0]?.link?.results?.[0]?.class}`}
                          >
                            {
                              school?.schoolcard?.results?.[0]?.link
                                ?.results?.[0]?.name
                            }
                            <span>
                              <Image
                                src={arrow}
                                alt="arrow"
                                width={16}
                                height={16}
                                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                              />
                            </span>
                          </button>
                        </Link>
                        <Link
                          href={
                            school?.schoolcard?.results?.[0]?.link?.results?.[1]
                              ?.hyperlink
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <button
                            // data-bs-dismiss="modal"
                            className={`${styles.enrol_now_button}`}
                            onClick={() => {
                              handleApplicationRedirection(dispatch,school?.name)
                            }}
                          >
                            {
                              school?.schoolcard?.results?.[0]?.link
                                ?.results?.[1]?.name
                            }
                            <span>
                              <Image
                                src={arrow}
                                alt="arrow"
                                width={16}
                                height={16}
                              />
                            </span>
                          </button>
                        </Link>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
          {processedData?.results?.length > 4 ? (
            <div className={`${styles.btn_scroll_wp}`}>
              <button
                onClick={gotoPrev}
                className={currentIndex === 0 ? styles.disabledButton : ""}
                disabled={currentIndex === 0}
              >
                <Image
                  src={left}
                  alt="previous"
                  width={24}
                  height={24}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />
              </button>
              <button
                onClick={gotoNext}
                className={
                  currentIndex >= lastSlideIndex ? styles.disabledButton : ""
                }
                disabled={currentIndex >= lastSlideIndex}
              >
                <Image
                  src={right}
                  alt="next"
                  width={24}
                  height={24}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />
              </button>
            </div>
          ) : processedData?.results?.length > 1 && isMobileDevice === true ? (
            <div className={`${styles.btn_scroll_wp}`}>
              <button
                onClick={gotoPrev}
                className={currentIndex === 0 ? styles.disabledButton : ""}
                disabled={currentIndex === 0}
              >
                <Image
                  src={left}
                  alt="previous"
                  width={24}
                  height={24}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />
              </button>
              <button
                onClick={gotoNext}
                className={
                  currentIndex >= lastSlideIndex ? styles.disabledButton : ""
                }
                disabled={currentIndex >= lastSlideIndex}
              >
                <Image
                  src={right}
                  alt="next"
                  width={24}
                  height={24}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ScrollingPartnership;
